import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const USER_GROUPS_TABLE_STATE_STORAGE_KEY = "userGroupsList";

export const USER_GROUPS_LIST_COLUMN_IDS = {
    NAME: "name",
    ASSIGNED_TO_CONTROLS: "assignedToControls",
} as const;

export const userGroupsListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: USER_GROUPS_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const userGroupsListColumnFiltersCodecMap = {
    [USER_GROUPS_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
};
